import { Injectable } from '@angular/core';
import { SoftwareModuleAccessConfiguration } from '../../core-data-model/ModuleAccess/ModuleAccess.model';
import { ApiService } from '../../system-services/Api.service';
import { UserProfileSettingsService } from '../../system-services/UserProfileSettings/UserProfileSettings.service';
import { ModuleAccessTransformer } from './ModuleAccess.datatransform';

@Injectable({ providedIn: 'root' })
export class ModuleAccessApiConnect {
    constructor(
        private userProfile: UserProfileSettingsService,
        private api: ApiService,
        private transform: ModuleAccessTransformer
    ) {}

    getSoftwareModuleAccessConfiguration(): Promise<SoftwareModuleAccessConfiguration> {
        return this.api
            .get<any>(
                `/api/v4/companies/${this.userProfile.currentCompany}/companysettings/softwaremoduleaccessconfig`
            )
            .then(([data]) => this.transform.configServerToClient(data));
    }
}
